import React, { ReactNode } from "react";
import classNames from "classnames";
import SectionContainer from "@/App/components/SectionContainer";

interface Props {
  title: string;
  children: ReactNode;
  readOnlyTheme?: boolean;
}

const TestClaimSectionContainer: React.FC<Props> = (props: Props) => {
  const { title, children, readOnlyTheme = true } = props;

  const wrapperClasses = classNames({ "read-only-form-page-wrapper": readOnlyTheme });

  return (
    <div className={wrapperClasses}>
      <SectionContainer headerTitle={title} sectionTitleWithBtn={false}>
        {children}
      </SectionContainer>
    </div>
  );
};

export default TestClaimSectionContainer;
